<div class="facility-details-view-container"
     fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).facility.write" (click)="modify()" mat-stroked-button
            color="primary">
      <mat-icon>create</mat-icon>
      <span> Edytuj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <h3>Doradcy Placówki</h3>
        <table mat-table [dataSource]="ofwcasDataSource">

          <!-- Position Column -->
          <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef> Imię i nazwisko</th>
            <td mat-cell *matCellDef="let element">
              <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.uuid]">
                {{ element.firstName }} {{ element.lastName }}
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status</th>
            <td mat-cell *matCellDef="let element">
              <button mat-raised-button [ngClass]="element.status.color + '-button'">{{ element.status.name }}</button>
            </td>
          </ng-container>
          <ng-container matColumnDef="portalDa">
            <th mat-header-cell *matHeaderCellDef> Widoczny na portalu DA</th>
            <td mat-cell *matCellDef="let element">
              <button
                mat-raised-button
                [ngClass]="isOfwcaActiveCoordinator(element) ? 'positive-button' : 'negative-button'">
                {{ isOfwcaActiveCoordinator(element) ? 'TAK' : 'NIE' }}
              </button>

              <!--              <div class="permission-source" *ngIf="getDobryAgentCoordinator(element) as coordinator">-->
              <!--                Agent DA: {{ coordinator.firstName }} {{ coordinator.lastName }}-->
              <!--              </div>-->
            </td>
          </ng-container>
          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef> Numer telefonu</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="getDobryAgentOrOfwcaPhone(element) as phone; else notDobryAgentOrOfwcaPhone">
                {{ phone | phone }}
              </ng-container>

              <ng-template #notDobryAgentOrOfwcaPhone>
                <mat-spinner diameter="10"></mat-spinner>
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> Email</th>
            <td mat-cell *matCellDef="let element">
              {{ getDobryAgentOrOfwcaEmail(element) }}
            </td>
          </ng-container>


          <ng-container matColumnDef="blog">
            <th mat-header-cell *matHeaderCellDef> Uprawnienia - blog</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.user360Profiles?.length > 0; else noUser360Blog">
                <button
                  mat-raised-button
                  [ngClass]="hasDobryAgentBlogAccess(element) ? 'positive-button' : 'negative-button'">
                  {{ hasDobryAgentBlogAccess(element) ? 'TAK' : 'NIE' }}
                </button>

                <!--                <div class="permission-source">-->
                <!--                  {{ getDobryAgentPermissionSourceLabel(element, 'blog') }}-->
                <!--                </div>-->
              </ng-container>

              <ng-template #noUser360Blog>
                Brak konta ASF360
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef> Uprawnienia - edycja wizytówki</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.user360Profiles?.length > 0; else noUser360Edit">
                <button
                  mat-raised-button
                  [ngClass]="hasDobryAgentBusinessCardEditAccess(element) ? 'positive-button' : 'negative-button'">
                  {{ hasDobryAgentBusinessCardEditAccess(element) ? 'TAK' : 'NIE' }}
                </button>
                <!--                <div class="permission-source">-->
                <!--                  {{ getDobryAgentPermissionSourceLabel(element, 'business_card') }}-->
                <!--                </div>-->
              </ng-container>

              <ng-template #noUser360Edit>
                Brak konta ASF360
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="avatar">
            <th mat-header-cell *matHeaderCellDef>Avatar</th>

            <td mat-cell *matCellDef="let element; let i = index">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <div class="agent-avatar">
                  <img
                    *ngIf="getAgentAvatarUrl(element); else noAgentAvatar"
                    [src]="getAgentAvatarUrl(element)"
                    alt="Avatar doradcy">

                  <ng-template #noAgentAvatar>
                    <mat-icon>person</mat-icon>
                  </ng-template>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <app-loading [loading]="loading" [description]="'Pobieranie listy ...'"></app-loading>
      </mat-card>
    </div>
  </div>
</div>
